
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../../services/authService';
import { showError, showSuccess } from '../../utils/alert';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    contactNumber: '',
    aadharNumber: '',
    dateOfJoining: '',
    educationLevel: '',
    bankAccount: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await registerUser(formData);
      console.log('✅ Registered successfully:', response);
      showSuccess('Registered successfully 👏');
      navigate('/login');
    } catch (err) {
      console.error('❌ Registration failed:', err);
      showError(err.message || 'Registration failed');
      setError(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registerPage">
      <div className="login-container">
        <div className="logo">
          <img className="asha_logo_login" src="/assest/logo/logo.png" alt="Logo" />
        </div>
        <h1 className="title">ASHA Worker System</h1>
        <p className="subtitle">Create New Account</p>

        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="input-field">
            <i className="fas fa-user icon"></i>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <i className="fas fa-phone icon"></i>
            <input
              type="tel"
              name="contactNumber"
              placeholder="Contact Number"
              value={formData.contactNumber}
              onChange={handleChange}
              required
              pattern="[0-9]{10}"
              title="Please enter a 10-digit phone number"
            />
          </div>

          <div className="input-field">
            <i className="fas fa-id-card icon"></i>
            <input
              type="text"
              name="aadharNumber"
              placeholder="Aadhaar Number"
              value={formData.aadharNumber}
              onChange={handleChange}
              required
              pattern="[0-9]{12}"
              title="Please enter a 12-digit Aadhaar number"
            />
          </div>

          <div className="input-field">
            <i className="fas fa-calendar-alt icon"></i>
            <input
              type="date"
              name="dateOfJoining"
              placeholder="Date of Joining"
              value={formData.dateOfJoining}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <i className="fas fa-graduation-cap icon"></i>
            <input
              type="text"
              name="educationLevel"
              placeholder="Education Level (optional)"
              value={formData.educationLevel}
              onChange={handleChange}
            />
          </div>

          <div className="input-field">
            <i className="fas fa-university icon"></i>
            <input
              type="text"
              name="bankAccount"
              placeholder="Bank Account Number (optional)"
              value={formData.bankAccount}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>

        <div className="auth-footer">
          Already have an account? <a href="/login" className="auth-link">Sign in</a>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
